import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "contact-list" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", null, "No contact persons are set for this agreement.", -1)
const _hoisted_4 = [
  _hoisted_3
]

import { PropType, ref } from 'vue'
import { AgreementContactPerson } from '@/modules/agreements/types'
import ContactInfo from './contact-info.vue'

// Props for contacts and types

export default /*#__PURE__*/_defineComponent({
  props: {
    contacts: {
        type: Array as PropType<AgreementContactPerson[]>,
        required: true
    },
    contactTypes: {
        type: Array as PropType<string[]>,
        required: true
    }
},
  emits: ['updateContact', 'deleteContact', 'addContact'],
  setup(__props, { expose, emit }) {



const contactRefs = ref([])
const defaultContactIdentifier = 'nonce'

function validateUniqueness () {
    const emailSet = new Set()
    let hasDuplicates = false
    contactRefs.value.forEach((contactRef: typeof ContactInfo) => {
        if (!contactRef || !contactRef.email) return false
        const email = contactRef.email()
        if (emailSet.has(email)) {
            hasDuplicates = true
            contactRef.markEmailAsDuplicated(true)
        } else {
            emailSet.add(email)
            contactRef.markEmailAsDuplicated(false)
        }
    })
    return !hasDuplicates
}

function validateAllContacts () {
    return contactRefs.value.every((contactRef) => {
        if (!contactRef) return true
        return contactRef.validate()
    })
}

function validateList (): boolean {
    return validateAllContacts() && validateUniqueness()
}



// Emit update event to parent component
function onUpdateContact (updatedContact: AgreementContactPerson) {
    if (!validateList()) return
    emit('updateContact', updatedContact)
}

function onDeleteContact (contactToDelete: AgreementContactPerson) {
    emit('deleteContact', contactToDelete)
    contactRefs.value = contactRefs.value.filter((cr) => cr.email() !== contactToDelete.emailIdentifier)
}

function addNewContact () {
    if (!validateList()) {
        return
    }
    const newContact = {
        name: '',
        email: '',
        types: [],
        emailIdentifier: defaultContactIdentifier
    }
    emit('addContact', newContact)
}

expose({
    validateList,
    isNewContact (contact: AgreementContactPerson) {
        return contact.emailIdentifier === defaultContactIdentifier
    }
})

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.contacts, (contact, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: contact.emailIdentifier || contact.email,
        class: "contact-item"
      }, [
        _createVNode(ContactInfo, {
          contact: contact,
          "contact-types": __props.contactTypes,
          ref_for: true,
          ref: (el) => contactRefs.value[index] = el,
          onUpdate: onUpdateContact,
          onDelete: onDeleteContact
        }, null, 8, ["contact", "contact-types"])
      ]))
    }), 128)),
    (!__props.contacts.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createVNode(_component_q_btn, {
      onClick: addNewContact,
      label: "Add Contact Person",
      color: "positive",
      "no-caps": "",
      unelevated: ""
    })
  ]))
}
}

})